<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormCorreoDestinatario" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th :class="StyleTh+' text-center'">#</th>
                                                    <th :class="StyleTh">Personal</th>
                                                    <th :class="StyleTh">Perfil</th>
                                                    <th :class="StyleTh">Correo</th>
                                                    <th :class="StyleTh">Msg Bienvenida</th>
                                                    <th :class="StyleTh">Cotización</th>
                                                    <th :class="StyleTh">Facturación</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(lista,index) in Usuarios" :key="index">
                                                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                                                    <td><h6 :class="StylePr">{{lista.NombreCompleto}}</h6></td>
                                                    <td><p :class="StyleTd">{{lista.Nombre}}</p></td>
                                                    <td><p :class="StyleTd">{{lista.Correo}}</p></td>
                                                    <td>
                                                        <div class="form-check"><input v-if="!ConfigLoad.ShowLoader" type="checkbox" v-model="lista.Bienvenida" class="form-check-input"></div>
                                                    </td>
                                                    <td><div class="form-check"><input v-if="!ConfigLoad.ShowLoader" type="checkbox" v-model="lista.Cotizacion" class="form-check-input"></div></td>
                                                    <td><div class="form-check"><input v-if="!ConfigLoad.ShowLoader" type="checkbox" v-model="lista.Facturacion" class="form-check-input"></div></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <CBtnSave v-if="segurity.Save" :poBtnSave="oBtnSave" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCorreoDestinatario';
export default {
    name: 'FormCorreoDestinatario',
    // props: ['Id'],
    components:{
        
    },
    data() {
        return {
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Destinatarios',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ShowBtnCancel:false,
                ReturnRoute: 'panelSubMenus',
                EmitSeccion: EmitEjecuta,
            },
            // objCorreoDestinatario:{

            // },
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            Emit: EmitEjecuta,
            Usuarios:[],
            CorreoDestinatarios:[]
        }
    },
    methods: {
        async Guardar(){
            let formData=new FormData();
            formData.set('CorreoDestinatarios',JSON.stringify(this.Usuarios));
            await this.$http.post('/correodestinatario',formData).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;
            this.oBtnSave.Toast = 1;
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            this.$toast.error(err.response.data.message);
            
        },
        Recuperar(){
            this.$http.get('/correodestinatario').then((res)=>{
                this.Usuarios=res.data.data;
                this.Usuarios.forEach(element => {
                    element.Bienvenida=false;
                    element.Cotizacion=false;
                    element.Facturacion=false;
                });
                this.segurity   = res.data.segurity;
            })
        },
        Regresar(){
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
        // METODOS PROPIOS
        ListaCorreoDestinatarios(){
            this.$http.get('/correosdestinatario').then((res)=>{
                this.CorreoDestinatarios=res.data.data;
                this.Usuarios.forEach(elementousuario=>{
                    let ListaFiltradaIds=this.CorreoDestinatarios.filter(elementocorreo=>elementocorreo.IdUsuario==elementousuario.IdUsuario);
                    // console.log(ListaFiltradaIds);
                    ListaFiltradaIds.forEach(elementofiltro=>{
                        // console.log(elementofiltro.Seccion,elementofiltro.IdUsuario);
                        // console.log(elementousuario.IdUsuario);
                        switch (elementofiltro.Seccion) {
                            case 'MSGBIENVENIDA':
                                elementousuario.Bienvenida=true;
                                break;
                            case 'COTIZACION':
                                elementousuario.Cotizacion=true;
                                break;
                            case 'FACTURACION':
                                elementousuario.Facturacion=true;
                                break;
                        }
                        // console.log(elementousuario);
                    })
                })
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
            // .finally(()=>{
            //     this.ConfigLoad.ShowLoader=false;
            // });
        }

    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        this.Recuperar();
        this.ListaCorreoDestinatarios();
        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>